import './GrafoInfoCard.scss'
import { Box, Card, CardContent, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface IGrafoInfoCard {
  data: any
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

type DataToShow = {
  nombre: string
  id: string //Número de identificación:
  tipo: string
  tipo_territorio: string[]
  pais: string
  perfil: string
  ciudad: string
  departamento: string
  territorio: string
  periodo: string
  auditor: string
  certificadora: string
  clickedType: string
  rol_mercado: string
}

const getLang = (language: string) => {
  if (language.includes('es')) {
    return 'es'
  } else if (language.includes('en')) {
    return 'en'
  } else if (language.includes('pt')) {
    return 'pt'
  }
}
export const GrafoInfoCard = ({ data, setIsModalOpen }: IGrafoInfoCard) => {
  const { t, i18n }: any = useTranslation()
  const language = getLang(i18n.language)
  const [dataToShow, setDataToShow] = useState<Partial<DataToShow>>()

  const handleCardClose = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (data) {
      const preData: Partial<DataToShow> = {}

      if ('id_socio_carbono' in data) {
        Object.assign(preData, {
          nombre: data.nome_socio,
          id: data.id_socio,
          tipo: t(`persona.tipo.${data.tipo}`),
          clickedType: 'socio',
        })
      } else if ('id_empresa_carbono' in data) {
        Object.assign(preData, {
          nombre: data.nombre_empresa,
          id: data.id_empresa,
          tipo: t(`empresa.tipo.${data.id_tipo_empresa}`),
          pais: t(`countries.${data.id_pais}`),
          perfil: data[`perfil_${language}`],
          rol_mercado: t(`empresa.rol.${data.id_rol}`),
          clickedType: 'empresa',
        })
      } else if ('id_proyecto_carbono' in data) {
        Object.assign(preData, {
          nombre: data.nombre_proyecto,
          departamento: data.departamento.join(','),
          tipo_territorio:
            data.id_tipo_territorio
              ?.map((id: string) => t(`territory_type.${id}`))
              .join(',') || '',
          territorio:
            t(`territory.${data.id_territorio}`) || t('no_disponible'),
          periodo: data.periodo || t('no_disponible'),
          auditor: data.verificador || t('no_disponible'),
          certificadora: data.estandar_certificacion || t('no_disponible'),
          clickedType: 'proyecto',
          pais: t(`countries.${data.id_pais}`),
        })
      }

      setDataToShow(preData)
    }
  }, [data, language])

  const getCardContent = () => {
    switch (dataToShow?.clickedType) {
      case 'socio':
        return (
          <ul className="infoCard_data">
            <li>
              <span className="infoCard_data_title">{dataToShow.nombre}</span>
            </li>
            <li>
              <strong>{t('numero_id')}: </strong>
              <span>{dataToShow.id}</span>
            </li>
            <li>
              <strong>{t('persona.type')}: </strong>
              <span>{dataToShow.tipo}</span>
            </li>
          </ul>
        )

      case 'empresa':
        return (
          <ul className="infoCard_data">
            <li>
              <span className="infoCard_data_title">{dataToShow.nombre}</span>
            </li>
            <li>
              <strong>{t('numero_id')}: </strong>
              <span>{dataToShow.id}</span>
            </li>
            <li>
              <strong>{t('empresa.tipo_entidad')}: </strong>
              <span>{dataToShow.tipo}</span>
            </li>
            <li>
              <strong>{t('empresa.rol_mercado')}: </strong>
              <span>{dataToShow.rol_mercado}</span>
            </li>
            <li>
              <strong>{t('project.country')}: </strong>
              <span>{dataToShow.pais}</span>
            </li>
            {dataToShow.perfil && (
              <li className="infoCard_data_perfil">
                <strong>{t('empresa.perfil')}: </strong>
                <span>{dataToShow.perfil}</span>
              </li>
            )}
          </ul>
        )
      case 'proyecto':
        return (
          <ul className="infoCard_data">
            <li>
              <span className="infoCard_data_title">{dataToShow.nombre}</span>
            </li>
            <li>
              <strong>{t('project.country')}: </strong>
              <span>{dataToShow.pais}</span>
            </li>
            <li>
              <strong>{t('project.departament')}: </strong>
              <span>{dataToShow.departamento}</span>
            </li>
            {dataToShow.tipo_territorio && (
              <li>
                <strong>{t('project.type_of_territory')}: </strong>
                <span>{dataToShow.tipo_territorio || t('no_disponible')}</span>
              </li>
            )}
            <li>
              <strong>{t('project.territory')}: </strong>
              <span>{dataToShow.territorio}</span>
            </li>
            <li>
              <strong>{t('project.project_period')}: </strong>
              <span>{dataToShow.periodo}</span>
            </li>
            <li>
              <strong>{t('project.auditor')}: </strong>
              <span>{dataToShow.auditor}</span>
            </li>
            <li>
              <strong>{t('project.certifier')}: </strong>
              <span>{dataToShow.certificadora}</span>
            </li>
          </ul>
        )
    }

    return
  }

  return (
    <Box sx={{ position: 'absolute', top: 65, right: 23, width: '300px' }}>
      <Card>
        <CardContent sx={{ position: 'relative', padding: '0 !important' }}>
          <>
            <IconButton
              style={{ position: 'absolute', right: 10, top: 0 }}
              aria-label="settings"
              onClick={handleCardClose}
            >
              <CloseIcon />
            </IconButton>
            {getCardContent()}
          </>
        </CardContent>
      </Card>
    </Box>
  )
}
